export default {
  reportsFilters: [],
  reportOfAttendances: [],
  employeeReport: [],
  servicesReport: []
};
